import { gql } from '@apollo/client';

export default gql`
  mutation UpdatePreferencesMutation(
    $audioMuted: Boolean
    $soundtrackMuted: Boolean
    $textTrackLanguage: String
    $lastViewedContent: UserPreferencesLastViewedContent
    $hotspotTutorialOptOut: Boolean
    $equirectangularPictureGyroscopeTutorialOptOut: Boolean
  ) {
    updatePreferencesMutation(
      audioMuted: $audioMuted
      soundtrackMuted: $soundtrackMuted
      textTrackLanguage: $textTrackLanguage
      lastViewedContent: $lastViewedContent
      hotspotTutorialOptOut: $hotspotTutorialOptOut
      equirectangularPictureGyroscopeTutorialOptOut: $equirectangularPictureGyroscopeTutorialOptOut
    ) @client {
      id
      version
      audioMuted
      soundtrackMuted
      textTrackLanguage
      lastViewedContent
      hotspotTutorialOptOut
      equirectangularPictureGyroscopeTutorialOptOut
    }
  }
`;
